import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()
  const [api] = useState(() => ({
    title: translate({
      id: 'companies.renameModal.title',
    }),
    footer: {
      add: translate({ id: 'companies.renameModal.footer.add' }),
      cancel: translate({ id: 'companies.renameModal.footer.cancel' }),
    },
    validation: {
      empty: translate({ id: 'companies.renameModal.form.validation.name.empty' }),
      maxLength: (limit: number) =>
        translate({
          id: 'companies.renameModal.form.validation.name.maxLength',
          values: { limit },
        }),
      alreadyExists: translate({ id: 'companies.renameModal.form.validation.name.alreadyExists' }),
    },
    form: {
      name: {
        label: translate({ id: 'companies.renameModal.form.name.label' }),
      },
    },
    toast: {
      success: translate({ id: 'companies.renameModal.toast.success' }),
    },
  }))

  return api
}
